import { ISyncParams } from './syncParams'

export const mockExtranetSync = async (payload: ISyncParams) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true)
    }, 3000)
  })
}
